import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/all';

function pageOurPlatform() {
    gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)
    const howItWorks = () => {
        const snapSections = document.querySelectorAll('.platform--hiw__anchor-section')
        const anchorBlocks = document.querySelectorAll('.platform--hiw__card-wrp')
        const productShots = document.querySelectorAll('.platform--hiw__shots-wrp img')
        const scrolling = {
            enabled: true,
            events: "scroll,wheel,touchmove,pointermove".split(","),
            prevent: (e) => e.preventDefault(),
            disable() {
                if (scrolling.enabled) {
                    scrolling.enabled = false;
                    window.addEventListener("scroll", gsap.ticker.tick, {
                        passive: true
                    });
                    scrolling.events.forEach((e, i) =>
                        (i ? document : window).addEventListener(e, scrolling.prevent, {
                            passive: false
                        })
                    );
                }
            },
            enable() {
                if (!scrolling.enabled) {
                    scrolling.enabled = true;
                    window.removeEventListener("scroll", gsap.ticker.tick);
                    scrolling.events.forEach((e, i) =>
                        (i ? document : window).removeEventListener(e, scrolling.prevent)
                    );
                }
            }
        }

        const snapToSection = (section, duration = 0.6) => {
            if (scrolling.enabled) {
                scrolling.disable()

                gsap.to(window, { duration: duration, scrollTo: section, onComplete: scrolling.enable })
            }
        }

        snapSections.forEach((s, i) => {
            let dot = anchorBlocks[i].querySelector('.platform--hiw__card__marker--dot')
            gsap.to(dot, {
                scrollTrigger: {
                    trigger: s,
                    start: 'top +=10%',
                    toggleActions: 'play none none reverse'
                },
                backgroundColor: '#162A88',
                duration: 0.2,
                ease: 'power4.out'
            })

            if (i !== 0) {
                let line = anchorBlocks[i - 1].querySelector('.platform--hiw__card__marker--progress')

                gsap.to(line, {
                    scrollTrigger: {
                        trigger: s,
                        start: 'top bottom',
                        end: 'top top',
                        scrub: true
                    },
                    scaleY: 1
                })

            }

            let productImg = productShots[i]
            gsap.from(productImg, {
                scrollTrigger: {
                    trigger: s,
                    start: 'top +=50%',
                    toggleActions: 'play none none reverse'
                },
                // x: '2em',
                opacity: 0,
                duration: 0.6,
                ease: 'power2.out'
            })

            // ScrollTrigger.create({
            //     trigger: s,
            //     start: 'top bottom-=10%',
            //     onEnter: () => {
            //         snapToSection(s)
            //         // if (i !== 0 && window.innerWidth >= 992) {}
            //     },
            //     onEnterBack: () => {

            //         if (i !== snapSections.length - 1 && window.innerWidth >= 992) {
            //             snapToSection(s)
            //         }
            //     }
            // })
        })
    }

    howItWorks()
}

export default pageOurPlatform